import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest,} from '@angular/common/http';
import {finalize, Observable} from 'rxjs';

import {environment} from 'src/environment';
import {StorageService} from '../services/storage/storage.service';
import {TranslateService} from "@ngx-translate/core";
import {LoadingService} from 'src/app/core/services/loading/loading.service';
import {isMobileBrowserDevice} from "../utils/isMobileBrowserDevice.util";

const loadingUrls = [
  '/v1/student/groups',
  '/v1/files',
  '/v1/auth/signin',
  '/v2/student/progresses/groups/'
];

@Injectable()
export class ApiInterceptor implements HttpInterceptor {
  constructor(
    private storageService: StorageService,
    private translationService: TranslateService,
    private loadingService: LoadingService
    ) {
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Exclude specific requests from adding the token
    if (request.url.includes('/assets/i18n/')) {
      return next.handle(request);
    }

    const isMobileBrowser = isMobileBrowserDevice();

    request = request.clone({
      setHeaders: {
        'Accept-Language': this.translationService.currentLang,
        'X-Device-Name': localStorage.getItem('mobile_app') ? 'MOBILE' : isMobileBrowser ? 'ADAPTIVE' : 'WEB'
      }
    })

    if (
      (request.url.includes('/auth/signin') && !request.url.includes('/auth/signintoken')) ||
      request.url.includes('/auth/signup') ||
      request.url.includes('/auth/registrationtoken/') ||
      request.url.includes('/auth/recoverpassword')
    ) {
      const corsRequest = request.clone({
        url: environment.baseUrl + request.url,
        setHeaders: {
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE',
          'Access-Control-Allow-Headers': 'Content-Type',
        },
      });
      return next.handle(corsRequest);
    }

    const token = this.storageService.getToken();
    if (!token) {
      // Handle case where token is not available (e.g., redirect to login)
    }

    const modifiedRequest = request.clone({
      url: request.url.includes(environment.converterBaseUrl)
        ? request.url
        : environment.baseUrl + request.url,
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });


    const shouldShowLoading =
      loadingUrls.some(url => request.url.includes(url))
      &&
      request.url.includes('videoviewed') === false;

    if (shouldShowLoading) {
      this.loadingService.showLoading();
    }

    return next.handle(modifiedRequest).pipe(
      finalize(() => {
        if (shouldShowLoading) {
          this.loadingService.hideLoading();
        }
      })
    );
  }
}
